import * as R from 'ramda';
import { AnswerT } from 'src/api/types/AnswerT';
import { QuestionT } from 'src/api/types/QuestionT';
import { TriggersetT, TriggerT } from 'src/api/types/TriggersetT';

function _isTriggerTriggered(trigger: TriggerT, answersGiven: AnswerT[]) {
  return R.any((answer: AnswerT) => trigger.id === answer.id)(answersGiven);
}

function _isTriggersetTriggered(
  triggerset: TriggersetT,
  answersGiven: AnswerT[]
) {
  return R.any((trigger: TriggerT) =>
    _isTriggerTriggered(trigger, answersGiven)
  )(triggerset.triggers);
}

export function questionMustBeSkipped(
  question: QuestionT,
  answersGiven: AnswerT[]
) {
  return R.any(
    (triggerset: TriggersetT) =>
      !_isTriggersetTriggered(triggerset, answersGiven)
  )(question.triggersets);
}
